/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
  smartphone: {
    width: 32,
    height: 32,
    viewBox: '0 0 24 24',
    data: '<rect pid="0" x="5" y="2" width="14" height="20" rx="2" ry="2"/><path pid="1" d="M12 18h.01"/>',
  },
});
